import { render, staticRenderFns } from "./Snapshot.vue?vue&type=template&id=2edf254a&"
import script from "./Snapshot.vue?vue&type=script&lang=js&"
export * from "./Snapshot.vue?vue&type=script&lang=js&"
import style0 from "./Snapshot.vue?vue&type=style&index=0&id=2edf254a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports